<template>
  <div class="app-wrapper hideSidebar">
    <div class="content-container">
      <sidebar class="sidebar-container" />
      <div class="main-container hasTagsView">
        <div :class="{'fixed-header':fixedHeader}">
          <navbar />
          <tags-view />
        </div>
        <app-main />
      </div>
    </div>

    <!-- 全局提醒 -->
    <!-- 帮助按钮 -->
    <div class="help-button" @click="showHelpModal = true">
      <div class="help-button-left" />
      <div class="help-button-right">
        <span class="help-icon">?</span>
        <span class="help-text">Help</span>
      </div>
    </div>

    <!-- 帮助 Modal -->
    <el-dialog
      title="Help"
      :visible.sync="showHelpModal"
      width="500px"
      :before-close="handleHelpModalClose"
    >
      <div class="help-content">
        <p>If you encounter problems in AI automatic identification or sending, please provide:</p>
        <p>1. Created user ("PRIM1F", for example)</p>
        <p>2. Document PDF</p>
        <p>3. Problem description</p>
        <br>
        <p>Send it to <span style="font-weight: bold; color: #67C23A">jerrytong@usprimeagency.com</span></p>
        <p>We will reply as soon as possible.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showHelpModal = false">Get It</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from './components'
import { mapState } from 'vuex'
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView
  },
  data() {
    return {
      showHelpModal: false // 帮助按钮
    }
  },
  computed: {
    ...mapState({
      showSettings: state => state.settings.showSettings,
      fixedHeader: state => state.settings.fixedHeader
    })
  },
  methods: {
    // 关闭帮助 Modal
    handleHelpModalClose() {
      this.showHelpModal = false
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "./mixin.scss";
  @import "../../styles/variables.scss";

  .content-container {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    width: calc(100% - 100px);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    transition: width 0.28s;
  }

  // 帮助按钮样式
.help-button {
  position: absolute;
  bottom: 120px;
  right: 0;
  display: flex;
  cursor: pointer;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 30px 0 0 30px;
  z-index: 10009;
}

.help-button-right {
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 60px;
  border-radius: 30px 0 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.help-icon {
  text-align: center;
  line-height: 30px;
  border-radius: 50%;
  color: white;
  font-size: 20px;
  width: 30px;
  height: 30px;
  font-weight: bold;
  background-color: #3B82F6;
}

// 帮助内容样式
.help-content {
  font-size: 14px;

  .p {
    padding: 4px 0;
  }
}
</style>
